<div class="message-editor">
  <div class="NgxEditor__Wrapper">
    <ngx-editor-menu
      *ngIf="Service.message || interfaceService.isTelesellerDomain"
      [toolbar]="toolbar"
      [editor]="interfaceService.editor"
      [dropdownPlacement]="'top'"
    ></ngx-editor-menu>
    <ngx-editor
      (focusIn)="onFocus.emit()"
      (click)="setTextAreaPosition()"
      [editor]="interfaceService.editor"
      [disabled]="false"
      [(ngModel)]="textMessage"
      [placeholder]="placeholder"
    ></ngx-editor>
  </div>
</div>
